import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=599a9222&lang=pug&"
import script from "./Verification.vue?vue&type=script&lang=ts&"
export * from "./Verification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports